export default {
  methods: {

    draw_Forms() {

      this.canvasForms = this.svg
      .append('g')
      .attr('transform', `translate(10, 10)`)
      .style('font-family', 'roboto')
      .attr('cursor', 'default')


      let main = this.title.main
      let sub = this.title.sub

      this.canvasForms
      .append('text')
      .attr('x', main.x).attr('y', main.y + main.tSize*0.4)
      .style('font-size', main.tSize).attr('fill', main.tColor)
      .attr('text-anchor', main.align)
      .text(main.name)
      
      this.canvasForms
      .append('text')
      .attr('x', sub.x).attr('y', sub.y + sub.tSize*0.4)
      .style('font-size', sub.tSize).attr('fill', sub.tColor)
      .attr('text-anchor', sub.align)
      .text(sub.name)



      this.gauge_Router()

      if (this.sundries) {
        let sunData = this.JQueries.sundriesConfig && this.JQueries.sundriesConfig.SQL ? this.Queries[this.JQueries.sundriesConfig.SQL][0] : this.DataItems[0]
        if(this.sundries.length > 0) this.gmx_Sundries(this.svg, this.sundries, sunData, this.JQueries.sundriesConfig.server)
      }
    },




    
  }
}